const initialState = {
    locale: "zh",
    theme: "",
    width: 0,
    height: 0,
    isMobile: false,
    isLogin: false,
    userName: "",
    menuList: [],
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "global":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "global",
    reducer: reducer,
};

export default data;
